import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { ISubDealerFilter, ISubDealerList } from '../models/models'

export class FilterVirtualPosInfosApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/virtualPosInfos/getAll',
      requesterInfo,
    })
  }

  public async filterVirtualPosInfos(request: ISubDealerFilter): Promise<ISubDealerList[]> {
    return await this.postAsync<ISubDealerList[]>(request)
  }
}
